import { useState } from "react";
import styles from "./SizeChart.module.scss";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { RulerOutlined as Ruler24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/RulerOutlined";
import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";

import { dispatchAnalyticsEvent } from "../../utils";

type Props = {
  sizeGuideContent: string;
};

export const SizeChartUI = ({ sizeGuideContent }: Props) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = async () => {
    setModalOpen(true);
    dispatchAnalyticsForSizeChart();
  };

  const dispatchAnalyticsForSizeChart = async () => {
    dispatchAnalyticsEvent(
      "pdp.modalOpened",
      { type: "size and delivery" },
      {},
    );
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const sizeChartText = "Size chart";

  return (
    <>
      <TertiaryButton
        small
        onClick={openModal}
        id="size-guide-button"
        data-cy="size-guide-button"
        data-testid="size-guide-button"
        data-component="SizeChart"
      >
        <div className={styles.sizeCharts}>
          <Ruler24PxOutlinedIcon size="medium" />
          <span className={styles.sizeChartLabel}>{sizeChartText}</span>
        </div>
      </TertiaryButton>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        width="medium"
        title={sizeChartText}
        footer={false}
      >
        <div
          data-testid="sizing-guide-content"
          className={styles.sizingGuideContainer}
          dangerouslySetInnerHTML={{ __html: sizeGuideContent }}
        />
      </Modal>
    </>
  );
};
